const MIN_REQUEST_DELAY = 300;
const LONG_REQUEST_DELAY = 1200;

export const delay = () => new Promise<void>(resolve => setTimeout(resolve, MIN_REQUEST_DELAY));
export const longDelay = () => new Promise<void>(resolve => setTimeout(resolve, LONG_REQUEST_DELAY));
